var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentorship({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9048 3.43861C14.6754 2.66802 14.7947 1.96111 15.3545 1.24878C15.7927 0.691163 16.6224 0.691163 17.0605 1.24878C17.6204 1.96111 17.7397 2.66802 18.5102 3.43861C19.2808 4.20919 19.9878 4.32847 20.7001 4.88826C21.2576 5.32646 21.2576 6.1561 20.7001 6.59429C19.9878 7.1541 19.2808 7.27339 18.5103 8.04395C17.7397 8.81455 17.6204 9.52144 17.0607 10.2338C16.6224 10.7914 15.7928 10.7914 15.3546 10.2338C14.7948 9.52144 14.6755 8.81455 13.9049 8.04395C13.1343 7.27337 12.4274 7.1541 11.7151 6.59429C11.1575 6.1561 11.1575 5.32646 11.7151 4.88826C12.4274 4.32847 13.1343 4.20918 13.9048 3.43861Z",
    stroke: "#F7A703",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92742 5.29346C6.80239 5.33128 5.69591 5.43837 4.61268 5.55912C2.79224 5.76203 1.32737 7.22691 1.13251 9.04823C0.988661 10.3927 0.867188 11.7731 0.867188 13.1804C0.867188 14.5877 0.988661 15.9681 1.13251 17.3126C1.32737 19.1339 2.79224 20.5988 4.61268 20.8017C5.96483 20.9524 7.35316 21.0818 8.76864 21.0818C10.1841 21.0818 11.5724 20.9524 12.9246 20.8017C14.745 20.5988 16.2099 19.1339 16.4048 17.3126C16.5283 16.1575 16.6355 14.976 16.6631 13.7737",
    stroke: "#F7A703",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77027 21.0818C7.35479 21.0818 5.96646 20.9523 4.61429 20.8016C4.40297 20.7781 4.19642 20.7375 3.99609 20.6814C4.22827 19.6044 4.85023 18.5473 5.70161 17.8514C6.56753 17.1437 7.65152 16.7571 8.76989 16.7571C9.88828 16.7571 10.9723 17.1437 11.8382 17.8514C12.7041 18.5592 13.2987 19.5446 13.5213 20.6406C13.5213 20.6406 13.5207 20.6582 13.5203 20.688C13.3276 20.7408 13.1291 20.779 12.9262 20.8016C11.5741 20.9523 10.1857 21.0818 8.77027 21.0818Z",
    stroke: "#F7A703",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75942 14.2815C10.3855 14.2815 11.3001 13.3669 11.3001 11.7409C11.3001 10.1148 10.3855 9.2002 8.75942 9.2002C7.1334 9.2002 6.21875 10.1148 6.21875 11.7409C6.21875 13.3669 7.1334 14.2815 8.75942 14.2815Z",
    stroke: "#F7A703",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorship);
export default __webpack_public_path__ + "static/media/Mentorship.6f1141902ab95b29097a77ab99b0649e.svg";
export { ForwardRef as ReactComponent };